/** @jsx jsx */

import React, { Fragment as _, useState, useRef } from 'react';
import { css, jsx } from '@emotion/core';
import arrow from 'assets/pointerLight.svg';
import { colors, getButtonFocus } from 'styles/variables';
import EmptyBtn from 'components/UI/EmptyBtn';
import checkReturnToInteractionEditing from 'services/checkReturnToInteractionEditing';
//

const { lPink, lGrey0, lGrey1, lGrey2 } = colors;

// rgba(0,0,0,0.4) #999999
// rgba(0,0,0,0.1)

const Btn = ({ dir = 'next', size = 60, style = {}, onClick }) => {
  //
  return (
    <EmptyBtn
      css={css`
        position: relative;
        flex-shrink: 0;
        width: ${size}px;
        height: ${size}px;
        margin: 20px;
        background: url(${arrow}) no-repeat;
        background-color: #494949;
        background-position: center;
        border-radius: 50%;
        transform: scaleX(${dir === 'next' ? 1 : -1});
        transition: all 0.2s;
        cursor: pointer;
        -webkit-backface-visibility: hidden;

        &:hover {
          opacity: ${'rgba(0,0,0,0.45)' || 0.8};
        }

        &:focus {
          ${getButtonFocus('#494949')}
        }
      `}
      style={style}
      onClick={() => {
        checkReturnToInteractionEditing();
        onClick();
      }}
    />
  );
};

const Btn_v2 = ({
  dir = 'next',
  size = 60,
  top = '',
  enabled = true,
  style = {},
  onClick,
  ...props
}) => {
  // const [isMouseHover, setIsMouseHover] = useState(false);
  const height = props.height || '100%';
  //

  // onMouseOver={(e: any) => {
  //   e.currentTarget.firstElementChild.blur();
  //   setIsMouseHover(true);
  // }}
  // onMouseOut={e => {
  //   setIsMouseHover(false);
  // }}

  // quick little ' hack ' to remove the outline when is mouse
  // outline still in effect when tabbing. . .
  // removed
  // ${isMouseHover &&
  //   `
  // :focus {
  //   outline: none;
  // }`}

  return (
    <div
      css={css`
        position: absolute;
        flex-shrink: 0;
        ${`${dir === 'prev' ? 'left' : 'right'} : 0px;`}
        top: 0;
        width: ${size + 20}px;
        height: ${height}px;
        background: transparent;
      `}
      onClick={e => {
        onClick();
      }}
    >
      <EmptyBtn
        css={css`
        position: absolute;
        flex-shrink: 0;
        ${`${dir === 'prev' ? 'left' : 'right'} : 10px;`}
        top: ${top ? top : '50%'};
        width: ${size}px;
        height: ${size}px;
        // margin: 20px;
        background: url(${arrow}) no-repeat;
        background-color: rgba(73, 73, 73, ${enabled ? 1 : 0.45});
        // background-color: ${enabled ? '#999' : 'rgba(0, 0, 0, 0.1)'};
        background-position: center;
        border-radius: 50%;
        transform: scaleX(${dir === 'next' ? 1 : -1}) translateY(-50%);
        transition: opacity 0.2s;

        cursor: ${enabled ? 'pointer' : 'auto'};
        // opacity: ${enabled ? 1 : 0.25};

        transition: background-color 0.1s;

        :-webkit-backface-visibility: hidden;

        ${enabled &&
          `&:hover {
            background-color: rgba(73, 73, 73, 0.45);
          }

          &:focus {
            ${getButtonFocus('#494949')}
          }
        `}

        // :focus {
        //   outline: none;
        //   border: 1px solid #2684FF;
        // }

        @media (max-width: 480px) {
          ${`${dir === 'prev' ? 'left' : 'right'} : 5px;`}
          // transform: scale(0.75);
          transform: scale(  ${dir === 'next' ? 0.75 : -0.75});
        
          transform-origin: center;
        }
      `}
        style={style}
        // added to ' wrapper '
        // onClick={e => {
        //   onClick();
        // }}

        ariaLabel={dir === 'prev' ? 'Previous slide' : 'Next slide'}
        disabled={!enabled}
      />
    </div>
  );
};

export default Btn_v2;
